import React from "react";
import SideMenuShared from "./SideMenuShared";

const SideMenuSmallScreenNew = () => <SideMenuShared variant="small" />;

export default SideMenuSmallScreenNew;
